export default class AuthConfig {
  constructor() {
    this.clientId = 'rDhb8cgTCrR5duqePd9aGkYULeBiNtnS';
    this.domain = 'cimpress.auth0.com';
    this.audience = 'https://api.cimpress.io/';
    this.logoutRedirectUri = `${window.location.origin}/#/logout`;
  }
}
